module.exports = __webpack_public_path__ + "h5/img/mfe_24.d2505b91.jpg";